import { Link } from 'react-router-dom';
import { en } from '@/i18n/en';

export function NotFoundPage() {
  return (
    <div className="container" style={{ padding: '80px 24px', textAlign: 'center' }}>
      <p className="mono muted" style={{ letterSpacing: '0.08em' }}>404</p>
      <h1 style={{ fontSize: 36, margin: '12px 0' }}>{en.errors.notFound.title}</h1>
      <p className="muted">{en.errors.notFound.lede}</p>
      <Link to="/" className="btn btn-primary" style={{ marginTop: 16 }}>{en.errors.notFound.back}</Link>
    </div>
  );
}
